import { FilterShop } from "../../../../../shop/frontend/web/js/classes/FilterShop.js";

/**
 *  Класс описывающий реализацию фильтра
 * @extends FilterShop
 */
export class Filter extends FilterShop {
	constructor() {
		super();
		this.$filterClear = $("#js-filter-clear");
		this.$filters = $(".js-filter-input");
		this.$items = $("#js-event-items");
		this.$more = $("#js-more");
		this.$message = $("#js-events-message");
		this.$calendarInput = $(".js-date-filter");
		this.$calendarLabel = $("#js-filter-label");
		this.$filterTitle = $("#js-filter-title");
		this.$filterWrapper = $("#js-filter-wrapper");
	}

	setActionMore() {
		this.$more.on("click", () => {
			this.page++;
			this.getRequest("append");
		});
	}
}
